export enum QuizAction {
  ROUTE = 'route',
  DISPATCH = 'dispatch',
}
